module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_BlackMatted_MockedUp.4d255e01.jpg";